import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { CSSProperties, DLightViewProp, Pretty, Typed, View, required } from "@dlightjs/dlight";
import { injectFuncToInitNodes } from "../Injection/utils";
interface VStackProps {
  spacing?: number;
  alignment?: "leading" | "tailing" | "center";
  width?: string;
  height?: string;
  style?: CSSProperties;
  class?: string;
}
class VStack extends View implements VStackProps {
  constructor() {
    super();
    this.setStyles = this.setStyles.bind(this);
    this.didMount = this.didMount.bind(this);
  }
  $p$spacing;
  spacing = 0;
  $$spacing = 1;
  $p$alignment;
  alignment: VStackProps["alignment"] = "leading";
  $$alignment = 2;
  $s$alignment = ["margin"];
  $p$width;
  width = "max-content";
  $$width = 4;
  $p$height;
  height = "100%";
  $$height = 8;
  $p$style;
  style?: VStackProps["style"] = {};
  $$style = 16;
  $p$class;
  class?: VStackProps["class"];
  $$class = 32;
  get children() {
    return this._$children;
  }
  margin;
  get $f$margin() {
    if (this._$cache("margin", [this.alignment])) {
      return this.margin;
    }
    return {
      leading: "0 auto 0 0",
      tailing: "0 0 0 auto",
      center: "0 auto"
    }[this.alignment!] ?? "0 auto 0 0";
  }
  nodes: any[] = [];
  setStyles(nodes: any) {
    View.loopShallowEls(nodes, (el: HTMLElement) => {
      el.style.flexShrink = "0";
      el.style.margin = this.margin;
    });
  }
  didMount() {
    this.setStyles(this.nodes);
    injectFuncToInitNodes(this.nodes, this.setStyles);
  }
  Body() {
    let $node0, $node1;
    this._$update = $changed => {
      if ($changed & 29) {
        $node0 && $$setStyle($node0, {
          ...this.style,
          height: this.height,
          width: this.width,
          rowGap: `${this.spacing}px`,
          display: "flex",
          flexDirection: "column"
        });
      }
      if ($changed & 32) {
        $node0 && $$setHTMLProp($node0, "className", () => this.class, [this.class]);
      }
    };
    $node0 = $$createElement("div");
    $$setHTMLProp($node0, "className", () => this.class, [this.class]);
    $$setStyle($node0, {
      ...this.style,
      height: this.height,
      width: this.width,
      rowGap: `${this.spacing}px`,
      display: "flex",
      flexDirection: "column"
    });
    $node1 = new $$ExpNode(this.children, []);
    View.addDidMount($node1, (node: any) => {
      this.nodes = node._$nodes;
    });
    $$insertNode($node0, $node1, 0);
    $node0._$nodes = [$node1];
    return [$node0];
  }
}
export default ((VStack as Pretty) as Typed<VStackProps>);